module.exports = __webpack_public_path__ + "img/logo.68050aff.png";